module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-17-d44473673ae9a39bc45c1426d366504d.jpg";